const Lng={
}
Lng['Contraseña']={es:'Contraseña',en:'Password',pt:'Seña'}
Lng['Usuario']={es:'Usuario (Email)',en:'User (Email)',pt:'Email'}
Lng['Salir']={es:'Salir',en:'Logout',pt:'Fechar sessão'}
Lng['Error de login']={es:'Error de login',en:'Login error',pt:'Erro de identificação'}
Lng['Error']={es:'Error',en:'Error',pt:'Erro'}
export default Lng;